<div class="overlay-modal" *ngIf="isOpen" (click)="onBackdropClick()">
  <div class="confirm-popover" (click)="$event.stopPropagation()">
    <div class="confirm-popover__title">
      {{ title | translate }}
    </div>
    <div class="confirm-popover__desc">
      {{ description | translate : descriptionParams }}
    </div>
    <div class="confirm-popover__actions">
      <button type="button" class="btn btn-decline mr-2" (click)="decline.emit()">
        {{ declineText || "BUTTON.DISCARD" | translate }}
      </button>
      <button type="button" class="btn btn-accept" [disabled]="acceptDisabled" (click)="accept.emit()">
        <span *ngIf="isAcceptLoading" class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
        <span class="btn-content">
          {{ acceptText || "BUTTON.ACCEPT" | translate }}
        </span>
      </button>
    </div>
  </div>
</div>
